import "@fontsource/fira-sans/300.css";
import "@fontsource/fira-sans/400.css";
import "@fontsource/fira-sans/500.css";
import "@fontsource/fira-sans/600.css";
import "@fontsource/miriam-libre/400.css";
import "@fontsource/miriam-libre/700.css";
import "./brand/colors.css";
import "./brand/typography.css";
import "./brand/spacing.css";
import "./brand/base.css";
import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { startSession } from "./auth.ts";
import { applyTheme, loadTheme } from "./theme.ts";

applyTheme(loadTheme());
const root = createRoot(document.getElementById("root")!);

startSession()
  .then((session) => {
    if (session)
      root.render(
        <StrictMode>
          <App session={session} />
        </StrictMode>,
      );
  })
  .catch(() => {
    root.render(
      <main className="main">
        <section className="welcome">
          <h1>Det gick inte att logga in</h1>
          <p className="lead">Ladda om sidan. Om det inte hjälper, kontakta AI Factory-teamet.</p>
        </section>
      </main>,
    );
  });
